<template>
  <div class="bg-lm-contrast/5 dark:bg-dm-contrast/10 rounded-md"></div>
</template>
